export function getLongTimezoneName(timezone: string): string {
    const dtf = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        timeZoneName: 'long'
    });

    const options = dtf.formatToParts(new Date())
        .find(part => part.type === 'timeZoneName');

    return options ? options.value : '';
}

export function getShortTimezoneName(timezone: string, defaultValue: string): string {
    const longName = getLongTimezoneName(timezone);

    if (!longName) {
        return '';
    }

    if (!longName.includes('GMT')) {
        return longName.split(' ')
            .map(word => word[0].toUpperCase())
            .join('');
    }

    return defaultValue;
}